export { default } from './svg/carina-chevron.svg';
